import {useEffect} from "react"
import axios from "axios"
import {API_LEXICONS} from "../constants/apiUrls"
import LexiconsModal from "../sections/lexicons-modal/LexiconsModal"
import LexiconsHeader from "../sections/lexicons-header/LexiconHeader"
import LexiconsContent from "../sections/lexicons-content/LexiconsContent"
import ConfirmationModal from "../components/confirmation-modal/ConfirmationModal"
import {useTranslation} from "react-i18next"
import {toast} from "react-toastify"
import {useNavigate} from "react-router-dom"
import {useSessionContext} from "../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../reactContext/contextCustomHooks/useTeamContext"
import {useLexiconsContext} from "../reactContext/contextCustomHooks/useLexiconsContext"
import useLexicons from "../swrCustomHooks/useLexicons"
import RequireStLicence from "../tools/RequireStLicence"

export default function Lexicons() {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {teamContext} = useTeamContext()
    const {lexiconsContext} = useLexiconsContext()
    const {mutateLexicons} = useLexicons()
    let navigate = useNavigate()

    const deleteConfirmation = (confirmation) => {
        if (confirmation) {
            const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}
            axios.delete(`${API_LEXICONS}/${lexiconsContext.isConfirmationModal.id}`, headersRequest)
            .then(() => {
                mutateLexicons()
                toast.success(t("Lexicon deleted"))
            })
            .catch((err) => {
                switch (err.response.data.message) {
                    case "Unable to delete lexicon because it is used by other resources.":
                        toast.error(t("Impossible to delete the lexicon because of its use in a project!"))
                        break
                    default:
                        toast.error(t("An error has occurred"))
                        break
                }
            })
        }
    }

    useEffect(() => {
        sessionContext.role === "admin" && navigate("/neurowide-dashboard")
    }, [])

    return (
        <>
        <RequireStLicence types={teamContext.licenceTypes} redirect={true}>
            <div className="VIEW LEXICONS">
                {lexiconsContext.isConfirmationModal.modal && <ConfirmationModal type={"lexicons"} setDeleteConfirmation={deleteConfirmation}/>}
                {lexiconsContext.isModal && <><LexiconsModal type={lexiconsContext.modalType}/></>}
                <LexiconsHeader/>
                <span className="line"></span>
                <LexiconsContent/>
            </div>
        </RequireStLicence>
        </>
    )
}